export default __webpack_public_path__ + "static/media/support-notes-logo-el-cronista.27137164.svg";